

import React from 'react';

export const ToolsHero: React.FC = () => {
    return (
        <>
            <header className="">
                <div style={{
                    backgroundImage: `url(${"ToolsHero.svg"})`,
                    backgroundSize: "cover",
                    backgroundRepeat: 'no-repeat', height: "100vh"
                }} className="container-fluid px-5">
                    <div className="row gx-5 align-items-center justify-content-center">
                        <div className="col-lg-5">
                            <lottie-player src="https://assets5.lottiefiles.com/packages/lf20_wd1udlcz.json" background="transparent" speed="0.5" style={{ width: "28rem" }} loop autoplay></lottie-player>

                        </div>

                        <div className="col-lg-7">
                            <div className=" text-lg-start">
                                <h1 style={{ color: "#CCB7FF", fontSize: "3rem" }} className="display-5 fw-bolder mb-2">Tools & Resources</h1>
                                <p className="lead fw-normal text-white mb-5">Resources that I wish I’d had when I first started, and I'm committed to offering as much for free as I possibly can.</p>

                            </div>
                        </div>

                    </div>
                </div>
            </header>


        </>

    );
};
